import React from 'react'
import { EditIndeedFlexCompanyFlowProvider } from './context/EditIndeedFlexCompanyFlowProvider'
import { EditIndeedFlexCompanyFlowMain } from './components/EditIndeedFlexCompanyFlowMain'
import { useIndeedFlexCompaniesWorkflowsContextValue } from '../../context/IndeedFlexCompaniesWorkflowsProvider'

export const EditIndeedFlexCompanyFlow = () => {
  const { editCompanyFlow } = useIndeedFlexCompaniesWorkflowsContextValue()

  if (!editCompanyFlow.company) {
    return null
  }

  return (
    <EditIndeedFlexCompanyFlowProvider>
      <EditIndeedFlexCompanyFlowMain company={editCompanyFlow.company} />
    </EditIndeedFlexCompanyFlowProvider>
  )
}
